import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  store_ids: yup.array().min(1, "At least one store is required"),
  target_amount: yup.string().required("Target amount is required"),
  start_date: yup.string().required("Start date is required"),
  end_date: yup.string().required("End date is required"),
});

export const useValidation = ({ ...params }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...params,
    },
  });
};
